<!--
Created on 2021-04-10
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
-->
<template>
  <div id="footer-bar" class="footer-bar-5">
    <router-link to="database" :class="{'active-nav': activeItem === 'database'}"><i data-feather="database" data-feather-line="1" data-feather-size="21" data-feather-color="red-dark" data-feather-bg="red-fade-light"></i><span>Databáza</span></router-link>
    <router-link to="customers" :class="{'active-nav': activeItem === 'customers'}"><i data-feather="users" data-feather-line="1" data-feather-size="21" data-feather-color="green-dark" data-feather-bg="green-fade-light"></i><span>Zákazníci</span></router-link>
    <router-link to="home" :class="{'active-nav': activeItem === 'home'}"><i data-feather="home" data-feather-line="1" data-feather-size="21" data-feather-color="blue-dark" data-feather-bg="blue-fade-light"></i><span>Domov</span></router-link>
    <router-link to="orders" :class="{'active-nav': activeItem === 'orders'}"><i data-feather="file" data-feather-line="1" data-feather-size="21" data-feather-color="brown-dark" data-feather-bg="brown-fade-light"></i><span>Objednávky</span></router-link>
    <router-link to="profile" :class="{'active-nav': activeItem === 'profile'}"><i data-feather="user" data-feather-line="1" data-feather-size="21" data-feather-color="dark-dark" data-feather-bg="gray-fade-light"></i><span>Profil</span></router-link>
  </div>
</template>

<script>
export default {
  name: 'FooterBar',
  props: {
    activeItem: String
  },
  setup() {
    
  },
}
</script>

<style>

</style>